import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = async () => {
  const supabase = inject(AuthService);
  const router = inject(Router);
  const session = supabase.getSession() ?? (await supabase.fetchSession());
  return session ? true : router.parseUrl('/login');
};
